import Layout from "../Partials/Layout";
import { useState, useEffect } from "react";
import useSWR from "swr";
import {
  axiosGet,
  axiosPost,
  moneyFormat,
  OP_BAL_Date,
  sharesCodesListDbName,
  verifyCustomerAccountCode,
} from "../Partials/Constants";
import { TextInput, Select, Avatar, Button } from "@mantine/core";
import PouchDb from "pouchdb";
import { showNotification } from "@mantine/notifications";

export default function CheckSharesBalanceView() {
  const [accountCode, setAccountCode] = useState("");
  const [customerBalance, setCustomerBalance] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [isWorking, setIsWorking] = useState(false);
  const [sharesCode, setSharesCode] = useState([]);

  useEffect(() => {
    getCodes();
  }, []);

  useEffect(() => {
    if (!accountCode) return;
    getCustomerName();
  }, [accountCode]);

  async function getCustomerName() {
    const result = await verifyCustomerAccountCode(accountCode);
    if (result) setCustomerName(result?.AccountName);
  }

  async function getCodes() {
    let output = [];
    let db = new PouchDb(sharesCodesListDbName);
    let docs = await db.allDocs({ include_docs: true, descending: true });
    if (docs) {
      for (const v of docs.rows) {
        output.push(v?.doc?.SharesCode);
      }
      setSharesCode(output);
    }
  }

  async function handleCheckBalance() {
    if (!accountCode)
      return showNotification({
        message: "Account code is required",
      });
    setIsWorking(true);
    //verify account code
    const result = await verifyCustomerAccountCode(accountCode).finally(() =>
      setIsWorking(false)
    );

    if (result && !result.AccountName) {
      setCustomerBalance(null);
      setCustomerName("");
      return showNotification({
        message: "Customer code seem incorrect",
      });
    }
    if (result) setCustomerName(result.AccountName);
    setIsWorking(true);
    let payload = {
      AccountCode: accountCode,
      ShareCode: selectedCode,
      OpeningBalanceDate: OP_BAL_Date,
      TransactionDate: new Date(),
    };
    const check = await axiosPost("shares", payload)
      .catch((err) =>
        showNotification({
          message: err,
        })
      )
      .finally(() => setIsWorking(false));
    setCustomerBalance(check);
  }

  return (
    <Layout showBackButton={true} title="Check Shares Balance">
      <div className="flex flex-col mt-4">
        <div className="flex items-center space-x-2 bg-gray-200 px-4 py-6 rounded-xl">
          <Avatar radius={"xl"} />
          <span className="font-medium">{customerName || "N/A"}</span>
        </div>

        <div className="flex flex-col space-y-4 mt-8">
          <TextInput
            required={true}
            value={accountCode}
            onChange={(e) => setAccountCode(e.target.value)}
            placeholder="Enter customer account code"
            size={"lg"}
            variant={"filled"}
            label="Enter customer account code"
          />

          <Select
            required={true}
            data={sharesCode}
            value={selectedCode}
            onChange={(e) => setSelectedCode(e)}
            label="Select share code type"
            placeholder="Select share code type"
            size={"lg"}
            variant={"filled"}
          />

          <Button
            onClick={() => handleCheckBalance()}
            size={"lg"}
            loading={isWorking}
          >
            Check Balance
          </Button>
        </div>
      </div>

      {customerBalance !== null && (
        <div className="mt-8 w-full bg-yellow-300 rounded-lg shadow flex items-center justify-center flex-col text-center text-2xl p-6">
          <span className="font-medium text-center">Account Balance is:</span>
          <b className="text-4xl text-center">{moneyFormat(customerBalance)}</b>
        </div>
      )}
    </Layout>
  );
}
